import {createSlice} from "@reduxjs/toolkit";

const initialGameTypeListState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  gameList: [],
  deletedGameType: [],
  selectedGame: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const GameTypeListSlice = createSlice({
  
  name: "gameType",
  initialState: initialGameTypeListState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    appGameTypeList: (state, action) => {
      const { totalCount, entities, selectedGame } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.selectedGame = selectedGame;
    },
    fetchGameList: (state, action) => {
      const { gameList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.gameList = gameList;
    },
    deleteGameType: (state, action) => {
      const { deletedGameType } = action.payload;
      state.error = null;
      state.deletedGameType = deletedGameType;
    },
  }
});
